// import { useContext } from 'react'
// import { engMonthNames, teluguMonthNames } from '../Data/StaticData'

export default function FormattedDate(dateInInteger) {
  // const { language } = useContext(LanguageContext)
  let formattedDate = ''
  let formattedYear = ''
  let formattedMonth = ''
  let formattedDay = ''
  const dateString = dateInInteger && dateInInteger.toString()
  if (dateString) {
    formattedYear = dateString.substr(0, 4)
    if (dateString.length > 4) {
      formattedMonth = dateString.substr(4, 2)
    }

    if (dateString.length > 6) {
      formattedDay = dateString.substr(6, 2)
    }

    if (dateString.length === 8) {
      formattedDate = formattedYear + '-' + formattedMonth + '-' + formattedDay
    } else if (dateString.length === 6) {
      formattedDate = formattedYear + '-' + formattedMonth
    } else {
      formattedDate = formattedYear
    }
  }

  return formattedDate
}
